<div class="mon-dialog-header">
    <page-header [header]="type.name + ' ' + ('found' | translate)"
                 [subHeader]="('Found' | translate) + ' ' + links.total + ' ' + (singularName | translateWithPlural:links.total:type.name)">
        <page-header-content>
            <!--<div class="row mon-dialog-delay-fadein">-->
                <!--<div class="col-48 inner-r-large outer-t-mini">-->
                    <!--<table-search mon-search-length="3"-->
                                  <!--class="inline-block outer-r-small pull-right"-->
                                  <!--theme="grey-theme"-->
                                  <!--placeholder-txt="{{'Search...' | translate}}"-->
                                  <!--model="vm.search"-->
                                  <!--get-page="vm.onSearch(search)">-->
                    <!--</table-search>-->
                <!--</div>-->
            <!--</div>-->
        </page-header-content>
    </page-header>
</div>
<div class="mon-dialog-body">
    <div class="mt-4 mx-4">
        <mon-tabs [options]="tabs"
                  [(status)]="activeTab"
                  (onSearch)="onSearch($event)"
                  (onStatus)="onStatus($event)"
                  [showSearch]="true"
                  [search]="search"
                  [minSearchLength]="1"
                  [showExportBtn]="!!exports[type.type]">
            <csv-export-button *ngIf="exports[type.type]" [exports]="exports[type.type]"></csv-export-button>
        </mon-tabs>
        <div class="card panel-monsido-card">
            <div class="card-body">
                <table-container class="pages-table-wrapper" [collection]="links"
                                 (onPageChange)="onPageChange($event)"
                                 (onPerPageChange)="onPageSizeChange($event)"
                                 [progress]="promise">
                    <table class="table table-hover table-fixed">
                        <thead>
                        <tr>
                            <th [ngClass]="{'col-sm-44': !scanDocuments, 'col-sm-40': scanDocuments}" translate>Title and URL</th>
                            <th class="col-sm-4" *ngIf="scanDocuments"></th>
                            <th class="col-sm-4"></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr *ngFor="let link of links">
                            <td class="text-ellipsis">
                                <url-title
                                        [title]="link.url"
                                        [url]="link.url"
                                        [active]="false" >
                                </url-title>
                            </td>
                            <td class="text-v-middle text-right" *ngIf="scanDocuments" [attr.aria-label]="'Documents' | translate">
                                <pages-button
                                        [text]="'Document' | translate"
                                        [textPlural]="'Documents' | translate"
                                        (callback)="openDialog(link, 'document')"
                                        [(ngModel)]="link.documents_count">
                                </pages-button>
                            </td>
                            <td class="text-v-middle text-right" [attr.aria-label]="'Pages' | translate">
                                <pages-button
                                        (callback)="openDialog(link, 'html')"
                                        [text]="'Page' | translate"
                                        [textPlural]="'Pages' | translate"
                                        [ngModel]="link.html_pages_count"
                                >
                                </pages-button>
                            </td>

                        </tr>
                        </tbody>
                    </table>
                </table-container>
            </div>
        </div>
    </div>
</div>
